module.exports = __webpack_public_path__ + "static/media/workflux-recoveryEmailSent.074cd5d4.svg";